const bugsnagClient = window.bugsnagClient || {
    notify: () => {},
};

export default bugsnagClient;
